 <template>
    <el-dialog class="w-el-dialog" :visible.sync="visible" width="800px" append-to-body title="添加客户" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">
        <el-form ref="form" :model="form" size="mini" label-position="top" v-loading="loading">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="客户名称" :rules="[{ required: true, message: '必填项' }]" :error="formError.name?.toString()" prop="name">
                        <el-input v-model="form.name" @input="form.invoice_unit_name = form.name" @blur="BaiduMap()" placeholder="请填写客户名称" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所属员工" :rules="[{ required: true, message: '必填项' }]" :error="formError.user_id?.toString()" prop="user_id">
                        <users-select v-model="form.user_id" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="客户手机号" :rules="[{ required: true, message: '请填写客户手机号' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }]" :error="formError.phone_t?.toString()" prop="phone_t">
                    <el-input v-model="form.phone_t" @input="form.invoice_unit_phone = form.phone_t" placeholder="用于客户微信服务号接收项目进度相关消息" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客户种类" :rules="[{ required: true, message: '必选项' }]" :error="formError.type_id?.toString()" prop="type_id">
                        <crm-customer-type-select v-model="form.type_id" placeholder="请选择客户种类" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="客户种类" :rules="[{ required: true, message: '必选项' }]" :error="formError.type_id?.toString()" prop="type_id">
                        <crm-customer-type-select v-model="form.type_id" placeholder="请选择客户种类" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="工作电话">
                        <el-input v-model="form.work_phone" @input="form.invoice_unit_phone = form.work_phone" placeholder="请填写客户工作电话" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider content-position="left">客户地址（选填）</el-divider>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="国家或地区">
                        <config-country-select v-model="form.country" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="省份">
                        <config-country-select-province v-model="form.country_province" :country="form.country" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="城市">
                        <config-country-select-city v-model="form.country_province_city" :province="form.country_province" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="详细地址">
                        <el-input v-model="form.address" @input="form.invoice_unit_address = form.address" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider content-position="left">开票信息（选填）</el-divider>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="开票单位名称">
                        <el-input v-model="form.invoice_unit_name" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开票单位税号">
                        <el-input v-model="form.invoice_unit_number" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="开票单位地址">
                        <el-input v-model="form.invoice_unit_address" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开票单位电话">
                        <el-input v-model="form.invoice_unit_phone" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="开票单位银行名称">
                        <el-input v-model="form.invoice_unit_bank_name" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开票单位银行卡号">
                        <el-input v-model="form.invoice_unit_bank_number" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <el-button size="mini" @click="Close()">取 消</el-button>
            <el-button size="mini" type="primary" @click="SubmitForm()" :loading="loading">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data () {
        return {
                        visible: false,
            loading: false,
            formError: {},
            form: {
                id: null,
                name: null,
                user_id: null,
                type_id: null,
                work_phone: null,
                phone_t: null,
                country: null,
                country_province: null,
                country_province_city: null,
                address: null,
                invoice_unit_name: null,
                invoice_unit_number: null,
                invoice_unit_address: null,
                invoice_unit_phone: null,
                invoice_unit_bank_name: null,
                invoice_unit_bank_number: null,
            }
        }
    },
    methods: {
        Open (id) {
            this.visible = true
            this.loading = true
            this.$http.post('/9api/crm/customer/first', { id: id }).then(rps => {
                this.form.id = rps.data.id
                this.form.name = rps.data.name
                this.form.user_id = rps.data.user_id
                this.form.type_id = rps.data.type_id
                this.form.work_phone = rps.data.work_phone
                this.form.phone_t = rps.data.phone_t
                this.form.country = rps.data.country
                this.form.country_province = rps.data.country_province
                this.form.country_province_city = rps.data.country_province_city
                this.form.address = rps.data.address
                this.form.invoice_unit_name = rps.data.invoice_unit_name
                this.form.invoice_unit_number = rps.data.invoice_unit_number
                this.form.invoice_unit_phone = rps.data.invoice_unit_phone
                this.form.invoice_unit_address = rps.data.invoice_unit_address
                this.form.invoice_unit_bank_name = rps.data.invoice_unit_bank_name
                this.form.invoice_unit_bank_number = rps.data.invoice_unit_bank_number
                this.loading = false
            })
        },
        Close() {
            this.loading = false
            this.visible = false
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate()
                }
            })
        },
        SubmitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.formError = {}
                    this.$http.post('/9api/customer/update', this.form).then(rps => {
                        this.loading = false
                        if (rps.data.state == 'error') {
                            this.formError = rps.data.body
                        }if (rps.data.state == 'success') {
                            this.$emit('onChange', rps.data.body)
                            this.$notify.success({title: '提示', message: '编辑成功', duration: 2000})
                            this.Close()
                        }
                    }).catch((error) => {
                      this.loading = false
                      console.error('提交失败:', error)
                    })
                }
            })
        },
        BaiduMap() {
            this.$http.post('/9api/baidu-map/address-search', { value: this.form.name }).then(rps => {
                this.form.country = '中国'
                this.form.country_province = rps.data.province
                this.form.country_province_city = rps.data.city
                this.form.address = rps.data.address
                this.form.invoice_unit_address = rps.data.address
            })
        }
    }  
}
</script>